var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVehicle7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "64.000000pt",
    height: "64.000000pt",
    viewBox: "0 0 64.000000 64.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,64.000000) scale(0.100000,-0.100000)",
    fill: "current",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M448 383 c-4 -37 -4 -37 -15 -13 -7 14 -12 19 -12 12 -1 -8 -8 -11 -18 -8 -44 13 -72 14 -70 3 1 -8 -7 -10 -23 -8 -14 3 -80 5 -148 5 -138 1 -141 -1 -153 -75 -4 -28 -1 -39 12 -47 14 -9 18 -7 23 13 11 45 75 57 91 18 5 -15 4 -15 -13 0 -23 21 -36 21 -56 1 -20 -20 -20 -38 0 -58 20 -21 30 -20 54 4 11 11 20 16 20 10 0 -5 24 -10 54 -10 50 0 59 4 101 40 26 22 51 38 56 34 5 -3 8 0 7 8 -2 7 6 13 17 13 14 0 28 -15 45 -49 33 -64 52 -76 79 -52 12 11 21 25 21 32 0 17 -28 44 -45 44 -7 0 -21 -7 -29 -16 -9 -8 -16 -11 -16 -5 0 6 10 15 21 22 27 14 65 -1 74 -31 3 -11 11 -18 16 -15 5 4 9 0 9 -7 0 -8 9 -14 20 -14 11 0 20 6 20 13 0 7 11 13 26 13 20 0 25 4 22 22 -2 12 -16 29 -32 38 -16 8 -33 24 -37 35 -4 11 -8 14 -8 8 -1 -7 -12 -13 -26 -13 -19 0 -25 5 -25 21 0 17 5 20 25 16 20 -3 25 -1 23 12 -2 12 -17 17 -55 19 l-52 3 -3 -38z m49 -25 c-3 -7 -5 -2 -5 12 0 14 2 19 5 13 2 -7 2 -19 0 -25z m-170 -23 c5 -4 2 -5 -6 0 -10 6 -13 4 -9 -6 4 -10 -2 -14 -21 -15 -14 0 -42 -4 -61 -7 -30 -6 -31 -5 -11 3 13 6 35 11 48 12 12 1 23 8 23 14 0 13 25 13 37 -1z m84 -2 c11 -13 11 -15 1 -9 -8 5 -26 12 -40 16 l-27 8 26 1 c15 1 33 -7 40 -16z m-296 -78 c0 -30 -39 -27 -43 3 -3 20 0 23 20 20 15 -2 23 -10 23 -23z m385 5 c0 -24 -26 -38 -42 -22 -16 16 -2 42 22 42 13 0 20 -7 20 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82 261 c4 -13 18 -16 19 -4 0 4 -5 9 -11 12 -7 2 -11 -2 -8 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466 261 c-4 -5 -2 -12 3 -15 5 -4 12 -2 15 3 4 5 2 12 -3 15 -5 4 -12 2 -15 -3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicle7);
export default __webpack_public_path__ + "static/media/vehicle7.8dadaaa0aa8c5537472fd05b3280293d.svg";
export { ForwardRef as ReactComponent };